import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    interest: "General Enquiry",
    message: ""
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    const templateParams = {
      from_name: formData.fullName,
      from_email: formData.email,
      interest: formData.interest,
      message: formData.message
    };

    emailjs.send(
      "service_tv9gtf2",
      "template_76u2tuo",
      templateParams,
      "VrYFX8oDdo8xvzNK4"
    ).then((response) => {
      alert("Message sent successfully!");
      setFormData({
        fullName: "",
        email: "",
        interest: "Free Vending Machine for Business",
        message: ""
      });
    }).catch((error) => {
      alert("Failed to send message. Please try again.");
    }).finally(() => {
      setIsSending(false);
    });
  };

  return (
    <div className='cf-outer-container'>
      <div id="ContactForm" className='cf-main-container'>
        <h2>Get In Touch</h2>

        <div className="cf-horizontal-wrapper">
          <div className="cf-left-block">
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=vtpaulson@gmail.com" target="_blank" rel="noopener noreferrer">
              <div className="cf-card">
                <div className="cf-icon-email"><i className="fa-regular fa-envelope" /></div>
                <div className='cf-card-text'>
                  <h3 className='cf-title'>Email Us</h3>
                  <p className='cf-subtext'>Get detailed information about our solutions.</p>
                  <p className='cf-highlight-email'>Connect with us through email</p>
                </div>
              </div>
            </a>

            <a href="https://maps.app.goo.gl/VvX92nDxWa5ExThi6?g_st=com.google.maps.preview.copy" target="_blank" rel="noopener noreferrer">
              <div className="cf-card">
                <div className="cf-icon-office"><i className="fa-solid fa-building-circle-exclamation"></i></div>
                <div className='cf-card-text'>
                  <h3 className='cf-title'>Office Location</h3>
                  <p className='cf-subtext'>Located in the heart of Kerala, our office is easily accessible and centrally connected.</p>
                  <p className='cf-highlight-office'>Thamarakulam Rd, Kochi, Kerala</p>
                </div>
              </div>
            </a>

            <a href="https://wa.me/message/6AZWR2XWHIYJD1" target="_blank" rel="noopener noreferrer">
              <div className="cf-card">
                <div className="cf-icon-whatsapp"><i className="fa-brands fa-whatsapp" /></div>
                <div className='cf-card-text'>
                  <h3 className='cf-title'>WhatsApp</h3>
                  <p className='cf-subtext'>Quick responses to your queries.</p>
                  <p className='cf-highlight-whatsapp'>Chat Now</p>
                </div>
              </div>
            </a>

            <div className='cf-extra-block'>
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=vtpaulson@gmail.com" target="_blank" rel="noopener noreferrer">
                <div className='cf-extra-card'>
                  <div className='cf-icon-location'><i className="fa-solid fa-location-dot" /></div>
                  <div className='cf-extra-text'>
                    <h4 className='cf-title'>Our Service Areas</h4>
                    <p className='cf-extra-description'>We serve across major cities in Kerala including Kochi, Ernakulam, Trissur, Kottayam. Expanding to more cities soon!</p>
                  </div>
                </div>
              </a>

              <div className='cf-extra-card'>
                <div className='cf-icon-time'><i className="fa-regular fa-clock" /></div>
                <div className='cf-extra-text'>
                  <h4 className='cf-title'>Response Time</h4>
                  <p className='cf-extra-description'>We typically respond within 2-4 hours during business hours (9 AM - 7 PM IST)</p>
                </div>
              </div>
            </div>
          </div>

          <form className="cf-form" onSubmit={handleSubmit}>
            <h2>Send us a Message</h2>

            <label htmlFor="fullName">Full Name *</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="interest">I'm Interested In *</label>
            <select
              id="interest"
              name="interest"
              value={formData.interest}
              onChange={handleChange}
              required
            >
              <option value="Custom Vending Solutions">General Enquiry</option>
              <option value="Partnership Opportunities">Partnership Opportunities</option>
            </select>

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Tell us about your requirements..."
              value={formData.message}
              onChange={handleChange}
            />

            <button type="submit" disabled={isSending}>
              {isSending ? "Sending..." : "Send Message"} <i className="fa-regular fa-paper-plane" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
